import { articleImages } from "./articleImages";
import modaCover from "@/assets/categories/moda.webp.asset.json";
import domAmbientCover from "@/assets/categories/dom-ambient.webp.asset.json";
import otrociCover from "@/assets/categories/otroci.webp.asset.json";
import obdarovanjeCover from "@/assets/categories/obdarovanje.webp.asset.json";
import naravnaKozmetikaCover from "@/assets/categories/naravna-kozmetika.webp.asset.json";

// kupish.si – enotne 3D studijske naslovnice (Slog A) za kategorije in podkategorije.
import kDrogerija from "@/assets/kupish/drogerija.webp";
import kElektronika from "@/assets/kupish/elektronika-avdio.webp";
import kAvtoElektronika from "@/assets/kupish/avto-elektronika.webp";
import kDomVrt from "@/assets/kupish/dom-vrt.webp";
import kAvtoOprema from "@/assets/kupish/avtomobilska-oprema.webp";
import kModaDodatki from "@/assets/kupish/moda-dodatki.webp";
import kSport from "@/assets/kupish/sport-prosti-cas.webp";
import kVse from "@/assets/kupish/vse-kategorije.webp";
import kNegaDoma from "@/assets/kupish/nega-doma.webp";
import kPripomocki from "@/assets/kupish/pripomocki-za-ciscenje.webp";
import kCistila from "@/assets/kupish/cistila.webp";
import kKrpe from "@/assets/kupish/krpe-za-ciscenje.webp";
import kAntibakterijski from "@/assets/kupish/antibakterijski-izdelki.webp";
import kOsebnaNega from "@/assets/kupish/osebna-nega.webp";
import kAvtoKamere from "@/assets/kupish/avto-kamere.webp";
import kProstorocno from "@/assets/kupish/prostorocno-telefoniranje.webp";
import kFmRadiji from "@/assets/kupish/fm-radiji.webp";
import kNapajalniki from "@/assets/kupish/napajlniki-in-polnilci.webp";
import kNosilci from "@/assets/kupish/nosilci-in-drzala.webp";
import kAvdioVideo from "@/assets/kupish/avdio-video.webp";
import kZabavna from "@/assets/kupish/zabavna-elektronika.webp";
import kSlusalke from "@/assets/kupish/slusalke.webp";
import kTelefonija from "@/assets/kupish/telefonija.webp";
import kZvocniki from "@/assets/kupish/prenosni-zvocniki.webp";
import kNadzorne from "@/assets/kupish/nadzorne-kamere.webp";
import kSportne from "@/assets/kupish/sportne-kamere.webp";
import kVaruske from "@/assets/kupish/otroske-varuske.webp";
import kVrt from "@/assets/kupish/vrt.webp";
import kKuhinja from "@/assets/kupish/kuhinja.webp";
import kPrti from "@/assets/kupish/prti.webp";
import kStojala from "@/assets/kupish/stojala.webp";
import kNakitNew from "@/assets/kupish/nakit.webp";
import kTesterji from "@/assets/kupish/testerji-alkoholiziranosti.webp";

// New custom category covers (used as right-side hero photo on category pages
// and as tile artwork on the homepage). Falls back to article images below.
export const categoryCovers: Record<string, string> = {
  // kupish.si kategorije
  "vse-kategorije": kVse,
  "vsi-izdelki": kVse,
  "ostalo": kVse,
  "drugo": kVse,
  "drogerija": kDrogerija,
  "elektronika-avdio": kElektronika,
  "avto-elektronika": kAvtoElektronika,
  "dom-vrt": kDomVrt,
  "avtomobilska-oprema": kAvtoOprema,
  "moda-dodatki": kModaDodatki,
  "sport-prosti-cas": kSport,
  "sport-in-prosti-cas": kSport,
  // podkategorije
  "nega-doma": kNegaDoma,
  "pripomocki-za-ciscenje": kPripomocki,
  "cistila": kCistila,
  "krpe-za-ciscenje": kKrpe,
  "antibakterijski-izdelki": kAntibakterijski,
  "osebna-nega": kOsebnaNega,
  "avto-kamere": kAvtoKamere,
  "prostorocno-telefoniranje": kProstorocno,
  "fm-radiji": kFmRadiji,
  "napajlniki-in-polnilci": kNapajalniki,
  "nosilci-in-drzala": kNosilci,
  "avdio-video": kAvdioVideo,
  "zabavna-elektronika": kZabavna,
  "slusalke": kSlusalke,
  "telefonija": kTelefonija,
  "prenosni-zvocniki": kZvocniki,
  "nadzorne-kamere": kNadzorne,
  "sportne-kamere": kSportne,
  "otroske-varuske": kVaruske,
  "vrt": kVrt,
  "kuhinja": kKuhinja,
  "prti": kPrti,
  "stojala": kStojala,
  "nakit": kNakitNew,
  "testerji-alkoholiziranosti": kTesterji,
  // starejše (Unikatna) kategorije – ohranjeno zaradi obstoječih povezav
  "moda": modaCover.url,
  "dom-ambient": domAmbientCover.url,
  "otroci": otrociCover.url,
  "obdarovanje": obdarovanjeCover.url,
  "naravna-kozmetika": naravnaKozmetikaCover.url,
};



// Map of category slug → cover image URL (reused from article/category artwork).
const SLUG_TO_KEY: Record<string, string> = {
  // Top categories
  "nakit": "unikatni-nakit-ki-pripoveduje-zgodbo",
  "moda": "unikatna-moda-in-dodatki-ki-poudarijo-vas-slog",
  "moda-dodatki": "unikatna-moda-in-dodatki-ki-poudarijo-vas-slog",
  "dom-ambient": "unikatni-izdelki-za-dom-ki-prinasajo-toplino",
  "naravna-kozmetika": "naravna-kozmetika-za-nego-telesa-in-duha",
  "otroci": "unikatni-izdelki-za-otroke",
  "obdarovanje": "unikatna-darila-za-posebne-priloznosti",
  // Subcategories – nakit
  "obeski-ogrlice": "unikatni-obeski-in-ogrlice",
  "prstani": "unikatni-prstani",
  "uhani": "unikatni-uhani",
  "zapestnice": "unikatne-zapestnice",
  // Subcategories – moda
  "oblacila": "unikatna-oblacila",
  "torbice": "unikatne-torbice",
  "klekljanje": "klekljanje",
  "kvackanje": "kvackanje",
  "strikanje": "strikanje",
  "tkanje": "tkanje",
  "prticki": "klekljanje",
  // Subcategories – dom
  "pohistvo": "unikatno-pohistvo",
  "dekoracija": "unikatna-dekoracija",
  "retro-dekor": "retro-dekor",
  "kuhinja": "unikatna-kuhinja",
  "slike": "unikatne-slike",
  "hisni-ljubljencki": "hisni-ljubljencki",
  // Subcategories – kozmetika
  "kopalne-soli": "kopalne-soli",
  "mazila-kreme": "naravna-mazila-kreme",
  "naravna-mila": "naravna-mila",
  "naravni-deodoranti": "naravni-deodoranti",
  "naravni-hidrolati": "naravni-hidrolati",
  // Subcategories – otroci
  "darila-za-otroke": "darila-za-otroke",
  "oblacila-otroci": "otroska-oblacila",
  "otroske-torbe": "otroske-torbe",
  "igrace": "otroske-igrace",
  // Subcategories – obdarovanje
  "darila-za-moske": "darila-za-moske",
  "darila-za-zenske": "darila-za-zenske",
  "poslovna-darila": "poslovna-darila",
};

export function categoryImage(slug: string | undefined | null, fallbackSlug?: string | null): string | null {
  if (slug && categoryCovers[slug]) return categoryCovers[slug];
  if (fallbackSlug && categoryCovers[fallbackSlug]) return categoryCovers[fallbackSlug];
  if (slug && SLUG_TO_KEY[slug] && articleImages[SLUG_TO_KEY[slug]]) {
    return articleImages[SLUG_TO_KEY[slug]];
  }
  if (fallbackSlug && SLUG_TO_KEY[fallbackSlug] && articleImages[SLUG_TO_KEY[fallbackSlug]]) {
    return articleImages[SLUG_TO_KEY[fallbackSlug]];
  }
  return null;
}
